const etransferConnectionOptions: { [key: string]: string } = {
  email: 'Email Address',
  phone: 'Phone Number',
};

export default etransferConnectionOptions;
